import Vue from 'vue'
import { Message } from 'element-ui'
import axios from 'axios'
// import { api } from '../../static/api.json'
// import {api} from '../../static/api.json' // 省市区数据

const errorHandle = {
  '404': '你访问的接口不存在！',
  '500': '系统内部错误，请等待'
}
// const baseHost = '/Appointment'
// const CancelToken = axios.CancelToken
// const source = CancelToken.source()

axios.defaults.baseURL = window.api
// axios.defaults.timeout = 2000

axios.interceptors.response.use(function (response) {
  let data = response.data
  return data
}, function (error) {
  const res = error.response
  Message.error({
    message: errorHandle[res.status]
  })
  return Promise.reject(error)
})

Vue.prototype.$http = axios

const getAppointmentList = async function (dataParams) {
  const APPOINTMENTLIST = `/Appointment/appointment/${dataParams.docId}/getAppointmentList`
  const res = await axios.post(APPOINTMENTLIST, dataParams.appDate)

  if (res.s === '1') {
    return res.r
  } else if (res.s === '0') {
    if (res.ec === '100') {
      // Message(res.em)
    } else {
      Message.error(res.em)
    }
  }
  return ''
}
const getPatientInfo = async function (dataParams) {
  const APPOINTMENTLIST = `/Appointment/appointment/${dataParams.emrId}/getPatientInfo`
  const res = await axios.post(APPOINTMENTLIST, dataParams.appDate)

  if (res.s === '1') {
    return res.r
  } else if (res.s === '0') {
    if (res.ec === '100') {
      // Message(res.em)
    } else {
      Message.error(res.em)
    }
  }
  return ''
}
const getClinicDiagList = async function (dataParams) {
  const APPOINTMENTLIST = `/Appointment/appointment/${dataParams.emrId}/getClinicDiagList`
  const res = await axios.post(APPOINTMENTLIST, dataParams.params)

  if (res.s === '1') {
    return res.r
  } else if (res.s === '0') {
    if (res.ec === '100') {
      // Message(res.em)
    } else {
      Message.error(res.em)
    }
  }
  return ''
}

export {getAppointmentList, getPatientInfo, getClinicDiagList}



// WEBPACK FOOTER //
// ./src/api/index.js